export const routes = {
  DETALLES: "/Detalles/:id",
  CATEGORIAS: "/Categorias/:id",
  HOME: "/",
  EXPLORE: "/Explore/",
  EXPLOREID: "/Explore/:id",
  EXPLORECATEGORY: "/ExploreCategory/:id",
  FREELANCERPROFILE: "/FreelancerProfile/:id",
  DASHBOARD_ADMIN: "admin",
  DASHBOARD_ADMIN_NEW: "admin-new",
  DASHBOARD_ADMIN_USERS: "Users",
  DASHBOARD_ADMIN_MESSAGES: "messages",
  DASHBOARD_ADMIN_FREELANCERS: "freelancers",
  DASHBOARD_ADMIN_CLIENTS: "clients",
  DASHBOARD_ADMIN_PROFILE: "profile",
  DASHBOARD_ADMIN_COLLABORATOR: "collaborator",
  DASHBOARD_ADMIN_FINANCES: "finances",
  DASHBOARD_ADMIN_HIGHLIGHT: "highlight",
  DASHBOARD_FREELANCER: "Freelancer",
  DASHBOARD_FREELANCERPROFILE: "Profile",
  DASHBOARD_FREELANCERSKILLS: "Skills",
  DASHBOARD_FREELANCEREDUCATION: "Education",
  DASHBOARD_FREELANCERCERTIFICATION: "Certification",
  DASHBOARD_FREELANCERWHYME: "WhyMe",
  DASHBOARD_FREELANCERDESCRIPTION: "Description",
  DASHBOARD_FREELANCERLANGUAGE: "Language",
  DASHBOARD_FREELANCER_ACCOUNT: "Account",
  DASHBOARD_FREELANCER_FINANCE: "Finance",
  DASHBOARD_FREELANCER_ACCOUNT_BASIC: "Basic",
  DASHBOARD_FREELANCER_ACCOUNT_PASSWORD: "Password",
  DASHBOARD_FREELANCER_ACCOUNT_DESACTIVE: "Desactive",
  DASHBOARD_FREELANCER_ACCOUNT_NOTIFICATIONS: "Notifications",
  DASHBOARD_FREELANCER_VERIFICATION: "Verifications",
  DASHBOARD_FREELANCER_VERIFICATION_PHONE: "Phone",
  DASHBOARD_FREELANCER_VERIFICATION_EMAIL: "Email",
  DASHBOARD_FREELANCER_PROJECTS: "Projects",
  DASHBOARD_FREELANCER_PROJECTS_DETAIL: "Detail/:id",
  DASHBOARD_FREELANCER_PROJECTS_INPROGRESS: "InProgress",
  DASHBOARD_FREELANCER_PROJECTS_FINISHED: "Finished",
  DASHBOARD_FREELANCER_PROJECTS_CANCELLED: "Cancelled",
  DASHBOARD_FREELANCER_PROJECTS_CONTRACTED: "Contracted",
  DASHBOARD_FREELANCER_MESSAGES: "Messages",
  DASHBOARD_SERVICES: "Services",
  DASHBOARD_Dashboard: "Dashboard",
  DASHBOARD_SERVICESACTIVE: "Active",
  DASHBOARD_SERVICENEW: "NewService",
  DASHBOARD_SERVICENEW_TITLE: "Title",
  DASHBOARD_SERVICENEW_PRICE: "Price",
  DASHBOARD_SERVICENEW_DESCRIPTION: "Description",
  DASHBOARD_SERVICENEW_REQUIREMENTS: "Requirements",
  DASHBOARD_SERVICENEW_FILES: "Files",
  DASHBOARD_SERVICENEW_PUBLISH: "Publish",
  SERVICE: "/Service/:id",
  NEWPROJECT: "/NewProject/:idService/:idPackage",
  LOGIN: "/Login",
  LOGOUT: "/Logout",
  HOME_POST: "/Posts",
  CREATE_POST: "/NewPost",
  EDIT_POST: "/EditPost/:id",
  PRODUCTS: "/Products",
  TECH_DATA: "/DatosTecnicos",
  ABOUT_US: "/AboutUs",
  POSTS: "/Blog",
  HELP_CENTER: "/help-center",
  CONTACT: "/contact",
  PRIVACITY: "/Privacity",
  TERMS: "/Terms",
};
  